import { Button, ButtonProps } from '@mui/material';

// ----------------------------------------------------------------------

/**
 * Button tùy chỉnh sử dụng màu nền theme.palette.primary.dark thông qua prop sx
 */
export default function DarkModeButton(props: ButtonProps) {
  return (
    <Button
      variant="contained"
      color="primary"
      {...props}
      sx={{
        // Áp dụng màu chủ đạo tối
        backgroundColor: (theme) => theme.palette.primary.main,
        
        // Ghi đè hiệu ứng hover/press
        '&:hover': {
          backgroundColor: (theme) => theme.palette.primary.dark,
        },
        // Hợp nhất các style tùy chỉnh khác nếu có
        // eslint-disable-next-line react/destructuring-assignment
        ...props.sx, 
      }}
    >
      {/* eslint-disable-next-line react/destructuring-assignment */}
      {props.children}
    </Button>
  );
}